"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.save = exports.validateStep = void 0;
const fp = require("fp-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const Actions = require("../../actions/subproject/wizard");
const FilesActions = require("../../actions/files");
const ActionTypes = require("../../actionTypes/subproject/wizard");
const errorHandling_1 = require("../../utils/errorHandling");
const validation_1 = require("../../utils/validation");
function validate(store, step) {
    const wizard = store.value.subproject.wizard;
    let validationResponse = fp.validation.success(true);
    if (step > 0) {
        validationResponse = (0, validation_1.ap)((0, validation_1.isNotEmpty)('name')(wizard))(validationResponse);
        if (wizard.notifyFollowing.length > 0) {
            const emails = wizard.notifyFollowing.split(',').reverse();
            for (const email of emails) {
                const trimmed = email.trim();
                if (trimmed.length > 0) {
                    validationResponse = (0, validation_1.ap)((0, validation_1.isEmail)('notifyFollowing')(trimmed).mapFailure(([{ key, value }]) => [{ key, value: `${email}: ${value}` }]))(validationResponse);
                }
            }
            validationResponse = (0, validation_1.ap)((0, validation_1.isNotificationLimit)(emails, 10))(validationResponse);
        }
    }
    if (step > 3) {
        // TODO add validation
    }
    return validationResponse.map(() => step);
}
function validateStep(action$, store) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CHANGE_STEP), (0, operators_1.mergeMap)((action) => (0, rxjs_1.of)(validate(store, action.payload).fold((e) => Actions.stepValidationFailed(e), (step) => Actions.stepValidationSuccess(step)))));
}
exports.validateStep = validateStep;
function save(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.SAVE_REQUEST), (0, operators_1.mergeMap)((action) => validate(store, 4).fold((e) => (0, rxjs_1.of)(Actions.stepValidationFailed(e)), () => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        url: `${baseUrl}api/subproject`,
        body: action.payload
    }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.saveSuccess(), FilesActions.refreshFiles())), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.saveFailed((0, errorHandling_1.parseAjaxErrorResponse)(error))))))));
}
exports.save = save;
//# sourceMappingURL=wizard.js.map